<template>
  <Wrapper>
    <Dashboard>
      <DisplayNameStep
        :given-names-options="givenNamesOptions"
        :initial-given-names="session.qualifiedGivenNames"
        :initial-names="session.qualifiedNames"
        :names-options="namesOptions"
        :show-cancel-button="true"
        :sub-title="'ident.steps.display_name.sub_title'"
        :title="'ident.steps.display_name.title'"
        @next="handleNext"
      />
    </Dashboard>
  </Wrapper>
</template>

<script setup lang="ts">
import { toast } from 'vue-sonner'
import { PersonalDetails, StepNavigation } from '@/types'
import { useNaturalPersons } from '@/composables/api/use-natural-persons.ts'
import { useUserSession } from '@/composables/use-user-session.ts'
import DisplayNameStep from '@/components/ident/steps/personal-data/DisplayNameStep.vue'
import Dashboard from '@/components/wrappers/Dashboard.vue'
import Wrapper from '@/components/wrappers/Wrapper.vue'

definePage({
  name: 'edit-display-name',
  meta: {
    titleKey: 'tab.edit_display_name',
    requiresAuth: true,
  },
})

const { t } = useI18n()
const router = useRouter()
const { session } = useUserSession()
const { updateNaturalPerson } = useNaturalPersons()

const givenNamesOptions = computed(
  () => session.value.qualifiedGivenNames?.split(' ') || [],
)
const namesOptions = computed(
  () => session.value.qualifiedNames?.split(' ') || [],
)

async function handleNext(eventData?: StepNavigation<PersonalDetails>) {
  const personUid = session.value.personUid
  const data = eventData?.data
  if (!personUid || !data) return

  try {
    await updateNaturalPerson(personUid, {
      givenNames: data.givenNames.split(' ').filter(Boolean),
      names: data.names.split(' ').filter(Boolean),
    })
  } catch {
    return
  }

  toast.success(t('settings.edit.success'))
  router.push({ name: 'settings' })
}
</script>
